import { createTheme } from '@material-ui/core';

export const themePreprod = createTheme({
	palette: {
		primary: {
			main: '#6D4C41',
		},
		secondary: {
			main: '#A1887F',
		},
		background: {
			default: '#6D4C41',
		},
	},
});
